import React from 'react';

const ShareModal = ({ eventUrl, eventTitle, onClose }) => {
  const copyToClipboard = () => {
    navigator.clipboard.writeText(eventUrl);
    alert("Link copied!");
  };

  const whatsappMessage = `Hey! Check out this event "${eventTitle}" 🎉:\n${eventUrl}`;
  const whatsappLink = `https://wa.me/?text=${encodeURIComponent(whatsappMessage)}`;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
      <div className="bg-[#202020] text-white p-6 rounded-2xl w-80 max-w-[90%] relative font-poppins shadow-lg">
        <button
          className="absolute top-3 right-4 text-white text-xl"
          onClick={onClose}
        >
          &times;
        </button>

        <h2 className="text-xl font-semibold mb-2">Share Event</h2>
        <p className="text-sm text-gray-300 mb-3">Send this link to your friends:</p>

        <input
          className="w-full p-2 rounded-lg bg-[#2a2a2a] text-white mb-3"
          value={eventUrl}
          readOnly
        />

        <button
          className="w-full bg-[#202020] hover:bg-[#2a2a2a] transition-colors text-white py-2 rounded-lg mb-3 font-medium border border-gray-600"
          onClick={copyToClipboard}
        >
          Copy Link
        </button>

        <a
          className="block w-full text-center bg-[#25D366] text-black font-semibold py-2 rounded-lg"
          href={whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          Share on WhatsApp
        </a>
      </div>
    </div>
  );
};

export default ShareModal;
